import script from "./form-tram.vue?vue&type=script&setup=true&lang=js"
export * from "./form-tram.vue?vue&type=script&setup=true&lang=js"

import "./form-tram.vue?vue&type=style&index=0&id=419779e5&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419779e5"]])

export default __exports__